define("shared/utils/formatters/ig-post-from-basic-display", ["exports", "moment", "later/models/ig-post", "shared/utils/get-hashtags"], function (_exports, _moment, _igPost, _getHashtags) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"moment",0,"later/models/ig-post",0,"shared/utils/get-hashtags"eaimeta@70e063a35619d71f
  const createIgPostFromBasicDisplay = (graphMedia, socialProfile) => {
    const {
      caption,
      id,
      permalink,
      timestamp,
      is_deleted: isDeleted,
      media_url
    } = graphMedia;
    const type = graphMedia.media_type?.toLowerCase();
    const tags = (0, _getHashtags.default)(caption);
    const isVideo = type === 'video';
    const thumbnailUrl = isVideo ? graphMedia.thumbnail_url : media_url;
    const username = socialProfile?.get('nickname') || graphMedia.username;
    const attrs = {
      caption,
      id,
      permalink,
      username,
      timeCollected: Date.now(),
      isDeleted,
      hasMedia: true,
      isSelected: false,
      createdTime: timestamp ? (0, _moment.default)(timestamp).unix() : undefined,
      type,
      tags,
      thumbUrl: thumbnailUrl,
      lowResUrl: thumbnailUrl,
      highResUrl: media_url,
      standardResUrl: thumbnailUrl,
      lowBandwidthVideoUrl: isVideo ? media_url : undefined,
      lowResVideoUrl: isVideo ? media_url : undefined,
      standardResVideoUrl: isVideo ? media_url : undefined,
      socialProfile,
      userId: socialProfile?.get('basicDisplayId') ?? undefined
    };
    return _igPost.default.create(attrs);
  };
  var _default = _exports.default = createIgPostFromBasicDisplay;
});